/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_ImageInputs */

const vi_fertilizer_image = /** @type {(inputs: Fertilizer_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình ảnh`)
};

/**

* @param {Fertilizer_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_image = /** @type {((inputs?: Fertilizer_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_image(inputs)
});